import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export const CARD = 'w-full rounded-xl border bg-white text-left shadow-[0_1px_2px_rgba(16,24,40,0.06)] transition-[border-color,box-shadow]';
export const FOCUSED = 'border-indigo-500 ring-4 ring-indigo-500/15';

/** Controls inside a card take clicks and typing, not canvas drags. */
export const INTERACTIVE = 'nodrag nopan';

/** A full-width row, so a port on its edge sits on the card's edge. */
export const Row = ({ className, children }: { className?: string; children: ReactNode }) => (
	<div className={cn('relative flex h-7 items-center gap-2 px-3', className)}>{children}</div>
);

export const CardHeader = ({ icon, title }: { icon: ReactNode; title: string }) => (
	<div className='flex h-11 items-center gap-1.5 border-b border-gray-300 px-3 text-[13px] leading-4.5 font-medium text-ink'>
		{icon}
		{title}
	</div>
);
